import React, {Component} from "react";
import {Table} from "reactstrap";
import toastr from "toastr";
import ToastOptions from "../../../../common/toast/toastr-config.js";
import AddButton from "../../../../common/AddButton/AddButton";
import LoadingSm from "../../../../common/Loading/Loading-sm";
import "./ApiKeys.css";
import DateText from "../../../../common/DateText/DateText";
import ActivationButton from "../../../../common/ActivationButton/ActivationButton";

class ApiKeys extends Component {
  mount = false;
  constructor(props) {
    super(props);
    this.state = {
      isGenerateKeyLoading: false,
      isDialogLoading: false
    }
  }

  componentWillMount() {
    this.mount = true;
  }

  componentWillUnmount() {
    this.mount = false;
  }

  generateApiKey = async () => {
    try {
      if (this.mount) {
        this.setState({isGenerateKeyLoading: true});
      }
      await this.props.addKey(this.props.sub);
      toastr.options = ToastOptions;
      toastr.success("Key has been generated.");
      if (this.mount) {
        this.setState({ isGenerateKeyLoading: false });
      }
    } catch(error) {
      if(this.mount){
        this.setState({ isGenerateKeyLoading: false });
      }
    }
  };

  reverseApiKey = async (credential) => {
    try {
      this.setState({isDialogLoading: true});
      let sub = {...this.props.sub}
      const reverseMap = {
        revoked: "approved",
        approved: "revoked"
      }
      sub.credentials = sub.credentials.map(cr => {
        return {
          apikey: cr.apikey,
          status: cr.apikey === credential.apikey ? reverseMap[cr.status] : cr.status,
          createdAt: cr.createdAt
        }
      })
      await this.props.updateSubscription(sub);
      toastr.options = ToastOptions;
      toastr.success("Key has been " + reverseMap[credential.status]);
      this.setState({
        isDialogLoading: false
      });

    } catch (error) {
      this.setState({
        isDialogLoading: false
      });
      toastr.options = ToastOptions;
      toastr.error(error.message, '', error.lineNumber);
    }
  }

  firstUpperCase(text) {
    if (typeof text !== 'string') return ''
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  populateTable = () => {


    return this.props.sub.credentials.map((credential, index) => {
      return (
          <tr key={`${credential}${index}`}>
            <td className="width-40">{credential.apikey}</td>
            <td className="width-20">{this.firstUpperCase(credential.status)}</td>
            <td className="width-30"><DateText date={credential.createdAt}/></td>
            <td className="width-10">
              {this.props.sub.isActive &&
              <ActivationButton
                  isActive={credential.status !== "revoked"}
                  description={`key ${credential.apikey}`}
                  toggleFunction={this.reverseApiKey}
                  item={credential}
                  header="key"
              />
              }
              {!this.props.sub.isActive && "Inactive Sub"}
            </td>
        </tr>
      );
    });
  };

  render() {
    return (
      <div className="account-keys">
        {this.props.sub.isActive &&
        <div className="generate-key-container">
          <AddButton
              name="Generate key"
              handleCreateDialogToggle={this.generateApiKey}
              className="btn-add-key"
          />
          {this.state.isGenerateKeyLoading &&
          <div>
            <LoadingSm/>
          </div>
            }
          </div>
        }

        <div className="api-keys-table">
          <Table hover className="table">
            <thead>
            <tr>
              <th className="width-40">Key</th>
              <th className="width-20">Status</th>
              <th className="width-30">Created</th>
              <th className="width-10">Action</th>
            </tr>
            </thead>
            <tbody>{this.populateTable()}</tbody>
          </Table>
        </div>
      </div>
    );
  }
}

export default ApiKeys;



// WEBPACK FOOTER //
// ./src/accounts/account-product-details/account-api-product-details/components/ApiKeys.js